export default {
  testing: 'testing',
  qa: 'qa',
  production: 'production',
  e2e: 'e2e',
  sandbox: 'sandbox'
}
